module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst additionalStyles = []\nconst colors = resourceData.colors || {}\nif(colors.fg) \t\t\tadditionalStyles.push(`--fec-tabStrip-tab-fg-color: ${colors.fg};`);\nif(colors.bg) \t\t\tadditionalStyles.push(`--fec-tabStrip-tab-bg-color: ${colors.bg};`);\nif(colors.bar) \t\t\tadditionalStyles.push(`--fec-tabStrip-tab-bar-color: ${colors.bar};`);\nif(colors.delimiter) \tadditionalStyles.push(`--fec-tabStrip-tab-delimiter-color: ${colors.delimiter};`);\nif(colors.button) \t\tadditionalStyles.push(`--fec-tabStrip-tab-button-color: ${colors.button};`);\nif(colors.buttonHover) \tadditionalStyles.push(`--fec-tabStrip-tab-button-hover-color: ${colors.buttonHover};`);\nif(colors.hoverFG) \t\tadditionalStyles.push(`--fec-tabStrip-tab-hover-fg-color: ${colors.hoverFG};`);\nif(colors.activeFG) \tadditionalStyles.push(`--fec-tabStrip-tab-active-fg-color: ${colors.activeFG};`);\nif(colors.activeBG) \tadditionalStyles.push(`--fec-tabStrip-tab-active-bg-color: ${colors.activeBG};`);\nif(colors.activeBar) \tadditionalStyles.push(`--fec-tabStrip-tab-active-bar-color: ${colors.activeBar};`);\nif(colors.icon) \t\tadditionalStyles.push(`--fec-tabStrip-tab-icon-color: ${colors.icon};`);\nlet title = config.static.title\nif(resourceData.title){\ntitle = resourceData.title\n}\nif(resourceData.titleSuffix){\ntitle += resourceData.titleSuffix\n}\n%><a class=\"item\" style=\"<%- additionalStyles.join(' '); %>\">\n<section class=\"content\">\n<div class=\"title\">\n<span><%= title %></span>\n<% if(resourceData.icon){ %>\n<i class=\"<%- resourceData.icon %> tab-icon\"></i>\n<% } else if(config.static && config.static.icon){ %>\n<i class=\"<%- config.static.icon %> tab-icon\"></i>\n<% } %>\n</div>\n</section>\n<% if((config || {}).closable){ %>\n<%- include('../form/elements/buttons/default', { formMapping: { buttonType: 'close', symbolOnly: true } }); %>\n<% } %>\n</a>"
  , __filename = "components/templates/core/tabStrip/tab.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const additionalStyles = []
const colors = resourceData.colors || {}
if(colors.fg) 			additionalStyles.push(`--fec-tabStrip-tab-fg-color: ${colors.fg};`);
if(colors.bg) 			additionalStyles.push(`--fec-tabStrip-tab-bg-color: ${colors.bg};`);
if(colors.bar) 			additionalStyles.push(`--fec-tabStrip-tab-bar-color: ${colors.bar};`);
if(colors.delimiter) 	additionalStyles.push(`--fec-tabStrip-tab-delimiter-color: ${colors.delimiter};`);
if(colors.button) 		additionalStyles.push(`--fec-tabStrip-tab-button-color: ${colors.button};`);
if(colors.buttonHover) 	additionalStyles.push(`--fec-tabStrip-tab-button-hover-color: ${colors.buttonHover};`);
if(colors.hoverFG) 		additionalStyles.push(`--fec-tabStrip-tab-hover-fg-color: ${colors.hoverFG};`);
if(colors.activeFG) 	additionalStyles.push(`--fec-tabStrip-tab-active-fg-color: ${colors.activeFG};`);
if(colors.activeBG) 	additionalStyles.push(`--fec-tabStrip-tab-active-bg-color: ${colors.activeBG};`);
if(colors.activeBar) 	additionalStyles.push(`--fec-tabStrip-tab-active-bar-color: ${colors.activeBar};`);
if(colors.icon) 		additionalStyles.push(`--fec-tabStrip-tab-icon-color: ${colors.icon};`);
let title = config.static.title
if(resourceData.title){
title = resourceData.title
}
if(resourceData.titleSuffix){
title += resourceData.titleSuffix
}

    ; __line = 22
    ; __append("<a class=\"item\" style=\"")
    ; __append( additionalStyles.join(' ') )
    ; __append("\">\n<section class=\"content\">\n<div class=\"title\">\n<span>")
    ; __line = 25
    ; __append(escapeFn( title ))
    ; __append("</span>\n")
    ; __line = 26
    ;  if(resourceData.icon){ 
    ; __append("\n<i class=\"")
    ; __line = 27
    ; __append( resourceData.icon )
    ; __append(" tab-icon\"></i>\n")
    ; __line = 28
    ;  } else if(config.static && config.static.icon){ 
    ; __append("\n<i class=\"")
    ; __line = 29
    ; __append( config.static.icon )
    ; __append(" tab-icon\"></i>\n")
    ; __line = 30
    ;  } 
    ; __append("\n</div>\n</section>\n")
    ; __line = 33
    ;  if((config || {}).closable){ 
    ; __append("\n")
    ; __line = 34
    ; __append( include('../form/elements/buttons/default', { formMapping: { buttonType: 'close', symbolOnly: true } }) )
    ; __append("\n")
    ; __line = 35
    ;  } 
    ; __append("\n</a>")
    ; __line = 36
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/core/tabStrip/tab.ejs

}